firebird.factory('videoLossIndicatorService', [
    '$interval',
    '$window',
    'logService',
    'connectivityService',
    'helperService',
    'configService',
    'videoGlobalService',
    function ($interval, $window, logService, connectivityService, helperService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoLossIndicatorService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // new code uses this from stats functions - every 10s.
            self.updateLossIndicator = updateLossIndicator;

            // old code used external getStats library - every 5s.
            //PeerConnections / GetStats
            self.getStatsInterval = 5 * 1000;
            self.applyGetStats = applyGetStats;
            self.getStatsCallback = getStatsCallback;
            self.sfuReceivedVideoStreamsInterval = null;
            self.startSfuReceivedVideoStreamsInterval = startSfuReceivedVideoStreamsInterval;
            self.cancelSfuReceivedVideoStreamsInterval = cancelSfuReceivedVideoStreamsInterval;

            // actual change is in 117+ but for buffer in testing, use 116.
            const fixStatsIn117 = configService.getClientValue('fixStatsIn117');
            if (fixStatsIn117) {
                if (fixStatsIn117 === 'true' || fixStatsIn117 === 'false')
                    self.fixStatsIn117 = fixStatsIn117 !== 'false';
                else self.fixStatsIn117 = fixStatsIn117; // string.
            } else {
                self.fixStatsIn117 = helperService.getChromeVersion() >= 116;
            }
        }

        function updateLossIndicator(result) {
            if (self.fixStatsIn117 !== true) {
                return;
            }
            if (!result || !result.length) {
                return;
            }

            let callMediaType = connectivityService.callMediaTypes.SFU;
            let transmissionType = 'sent';
            let mediaType = 'audio';

            const audioTx = result.find(item => item.media == 'audio' && item.dir == 'outbound');

            if (audioTx) {
                const packetsLost = audioTx?.packetsLost || 0;
                const packetsSent = audioTx?.packets || 0;

                if (packetsLost || packetsSent) {
                    const streamData = { packetsLost, packetsSent };
                    if (packetsLost) {
                        logger.log('videoroomCtrl updateLossIndicator', streamData, mediaType, transmissionType);
                    }
                    connectivityService.trackPacketLoss(streamData, mediaType, transmissionType, callMediaType, true);
                }
            }

            callMediaType = connectivityService.callMediaTypes.SFU;
            transmissionType = 'received';
            mediaType = 'audio';

            const audioRx = result.find(item => item.media == 'audio' && item.dir == 'inbound');

            if (audioRx) {
                const packetsLost = audioRx?.packetsLost || 0;
                const packetsReceived = audioRx?.packets || 0;

                if (packetsLost || packetsReceived) {
                    const streamData = { packetsLost, packetsReceived };
                    const packetsLostInPercent = packetsLost ? (packetsLost / packetsReceived) * 100 : 0;
                    if (packetsLost && packetsLostInPercent > 5) {
                        logger.log('videoroomCtrl updateLossIndicator', streamData, mediaType, transmissionType);
                    }
                    connectivityService.trackPacketLoss(streamData, mediaType, transmissionType, callMediaType, true);
                }
            }

            callMediaType = connectivityService.callMediaTypes.SFU;
            transmissionType = 'sent';
            mediaType = 'video';

            const videoTx = result.find(item => item.media == 'video' && item.dir == 'outbound' && !item.screen);
            if (videoTx) {
                const packetsLost = videoTx?.packetsLost || 0;
                const packetsSent = videoTx?.packets || 0;

                if (packetsLost || packetsSent) {
                    const streamData = { packetsLost, packetsSent };
                    if (packetsLost) {
                        logger.log('videoroomCtrl updateLossIndicator', streamData, mediaType, transmissionType);
                    }
                    connectivityService.trackPacketLoss(streamData, mediaType, transmissionType, callMediaType, true);
                }
            }

            callMediaType = connectivityService.callMediaTypes.SCREENSHARE;
            transmissionType = 'sent';
            mediaType = 'video';

            const screenTx = result.find(item => item.media == 'video' && item.dir == 'outbound' && item.screen);
            if (screenTx) {
                const packetsLost = screenTx?.packetsLost || 0;
                const packetsSent = screenTx?.packets || 0;

                if (packetsLost || packetsSent) {
                    const streamData = { packetsLost, packetsSent };
                    if (packetsLost) {
                        logger.log('videoroomCtrl updateLossIndicator', streamData, mediaType, transmissionType);
                    }
                    connectivityService.trackPacketLoss(streamData, mediaType, transmissionType, callMediaType, true);
                }
            }

            callMediaType = connectivityService.callMediaTypes.SFU_RECEIVED_VIDEO;
            transmissionType = 'received';
            mediaType = 'video';

            const videoRx = result.filter(item => item.media == 'video' && item.dir == 'inbound');
            if (videoRx.length > 0) {
                const adder = (a, b) => a + b;
                const packetsLost = videoRx.map(item => item.packetsLost).reduce(adder, 0);
                const packetsReceived = videoRx.map(item => item.packets).reduce(adder, 0);
                if (packetsLost || packetsReceived) {
                    const streamData = {
                        packetsLost,
                        packetsReceived: Math.max(packetsReceived, packetsLost)
                    };
                    const packetsLostInPercent = packetsLost ? (packetsLost / packetsReceived) * 100 : 0;
                    if (packetsLost && packetsLostInPercent > 5) {
                        logger.log('videoroomCtrl updateLossIndicator', streamData, mediaType, transmissionType);
                    }

                    connectivityService.trackPacketLoss(streamData, mediaType, transmissionType, callMediaType, true);
                }
            }
        }

        function applyGetStats(peerConnection, callMediaType, data, receivedVideoAttendantId) {
            if (self.fixStatsIn117) {
                logger.log('videoroomCtrl ignore applyGetStats on fixStatsIn117');
                return;
            }

            if (peerConnection.getStatsApplied === true) {
                return;
            }

            if (self.layoutPage && !self.sendStatsInternal) {
                // do not use getStats.
                peerConnection.getStatsApplied = true;
                return;
            }

            // crossbrowser compatibility check.
            // Firefox causes issues with external getStats lib
            if (helperService.isFirefox()) {
                logger.log('videoroomCtrl ignore applyGetStats on Firefox');
                return;
            }

            if (helperService.browserHasWebRTC()) {
                $window.getStats(
                    peerConnection,
                    function (result) {
                        var stopGetStatsInterval = false;

                        if (result.ended) {
                            //getStats interval has stopped for this pc
                            peerConnection.getStatsApplied = false;
                        }

                        //getStats will go through a few intervals after a pc closes before the interval stops on its own
                        //this is to stop it manually
                        if (peerConnection.connectionState === 'closed') {
                            stopGetStatsInterval = true;
                        }

                        var initialPLState = connectivityService.getOutboundPacketLossState();
                        self.getStatsCallback(
                            result,
                            callMediaType,
                            data,
                            receivedVideoAttendantId || 0,
                            stopGetStatsInterval
                        );
                        connectivityService.determineNewPLStateAndSendToServer(initialPLState);
                    },
                    self.getStatsInterval
                );

                peerConnection.getStatsApplied = true;
            } else {
                logger.error('applyGetStats', 'cannot call getStats due to invalid client browser');
            }
        }

        function getStatsCallback(result, callMediaType, data, receivedVideoAttendantId, abort) {
            if (self.fixStatsIn117) {
                return;
            }

            if (abort) {
                logger.log('videoroomCtrl closing getStats ' + callMediaType);
                if (result && typeof result.nomore === 'function') {
                    result.nomore();
                }
                return;
            }

            if (!result || !Array.isArray(result.results)) {
                return;
            }

            result.results.forEach(function (r) {
                //Synchronization source (SSRC): The source of a stream of RTP packets
                if (r.type === 'ssrc' || r.ssrc) {
                    var transmissionType;

                    if (r.packetsSent) {
                        transmissionType = 'sent';
                    } else if (r.packetsReceived) {
                        transmissionType = 'received';
                    }

                    //newer versions of Chrome use r.mediaType
                    var mediaType = r.kind || r.mediaType;

                    //For older versions of chrome
                    if (!mediaType && r.transportId) {
                        if (r.transportId.indexOf('audio')) {
                            mediaType = 'audio';
                        } else if (r.transportId.indexOf('video')) {
                            mediaType = 'video';
                        }
                    }

                    if (!transmissionType || !mediaType) {
                        return;
                    }

                    if (callMediaType === connectivityService.callMediaTypes.SFU_RECEIVED_VIDEO) {
                        if (receivedVideoAttendantId) {
                            var att = self.findAttendee(receivedVideoAttendantId);
                            var streamOwnerIdentifier = receivedVideoAttendantId;

                            //Prioritize attendendantLoginId because it is unique to each client's session
                            if (att && att.attendantLoginId) {
                                streamOwnerIdentifier = att.attendantLoginId;
                            }

                            connectivityService.addToSfuReceivedVideoStreamsList(streamOwnerIdentifier, {
                                packetsLost: r.packetsLost,
                                packetsReceived: r.packetsReceived
                            });

                            //There is a separate interval running to call trackPacketLoss on received video streams
                            return;
                        } else {
                            logger.error(
                                'getStatsCallback',
                                'Invalid receivedVideoAttendantId',
                                receivedVideoAttendantId
                            );
                        }
                    }

                    var shouldTrackQuality = false;

                    if (transmissionType === data.transmissionType || data.transmissionType === 'all') {
                        if (mediaType === data.mediaType) {
                            shouldTrackQuality = true;
                        }
                    }

                    if (shouldTrackQuality) {
                        connectivityService.trackPacketLoss(r, mediaType, transmissionType, callMediaType);
                    }
                }

                if (
                    callMediaType === connectivityService.callMediaTypes.SCREENSHARE &&
                    helperService.isChrome() &&
                    r.type === 'VideoBwe'
                ) {
                    connectivityService.trackStunRequests(r, connectivityService.callMediaTypes.SCREENSHARE);
                }
            });
        }

        function startSfuReceivedVideoStreamsInterval() {
            if (self.fixStatsIn117) {
                return;
            }

            if (!self.sfuReceivedVideoStreamsInterval) {
                self.sfuReceivedVideoStreamsInterval = $interval(function () {
                    var streamStats = connectivityService.getSfuReceivedVideoStreamsAggregate();
                    connectivityService.trackPacketLoss(
                        streamStats,
                        'video',
                        'received',
                        connectivityService.callMediaTypes.SFU_RECEIVED_VIDEO
                    );
                }, self.getStatsInterval);
            }
        }

        function cancelSfuReceivedVideoStreamsInterval() {
            if (self.fixStatsIn117) {
                return;
            }

            if (self.sfuReceivedVideoStreamsInterval) {
                $interval.cancel(self.sfuReceivedVideoStreamsInterval);
                self.sfuReceivedVideoStreamsInterval = null;
            }
        }
    }
]);
